import { h, render, Component } from 'preact'

import PlayerFilter from './player-filter-component'
import SeasonSelector from './season-selector-component'

export default class FilterBar extends Component {
  constructor(props) {
    super(props)

    this.handleFilterChange = this.handleFilterChange.bind(this)
  }
  
  handleFilterChange(e) {
    const chkbox = e.currentTarget

    if ( chkbox.checked ) {
      this.props.onAddFilter(chkbox.name)
    } else {
      this.props.onRemoveFilter(chkbox.name)
    }
  }
  
  render(props, state) {
    const clearFilter = (
        <li class='player-filter-list-item player-filter-list-item-clear-all'>
          <a class='player-filter-clear' onClick={ props.onClear }><i class='ss-icon'>&#x232B;</i> CLEAR FILTERS</a>
        </li>
    )
    
    const showClearFilter = (props.rookies || props.minimum || props.positions)
      
    const positionFilters = ['PG', 'SG', 'SF', 'PF', 'C'].map((p) => {
      const currentPositions = new Set(props.positions)
      return <PlayerFilter filterName={ p } label={ p } isActive={ currentPositions.has(p) } onChange={ this.handleFilterChange }/>
    })

    let minMinuteFilter = ''

    if ( props.minMinutesThreshold ) {
      minMinuteFilter = <PlayerFilter filterName='minimum' label={ `≥ ${props.minMinutesThreshold}m` } isActive={ props.minimum } onChange={ this.handleFilterChange }/>      
    }

    return(
      <div>
        <SeasonSelector selectedYear={ props.season } onSeasonChange={ this.props.onSeasonChange } isPlayoffs={ this.props.isPlayoffs } />
        <div class='filter-bar-container'>
          <label class='filter-bar-label'>FILTER:</label>
          <ul class='player-filter-list'>
            <PlayerFilter filterName='rookies' label='Rookie' isActive={ props.rookies } onChange={ this.handleFilterChange }/>
            { minMinuteFilter }
            { positionFilters }
            { showClearFilter ? clearFilter : '' }
          </ul>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/components/player-filter-list-component.js